export const COLORS = [
  'gray',
  'red',
  'orange',
  'yellow',
  'lime',
  'green',
  'teal',
  'cyan',
  'blue',
  'indigo',
  'violet',
  'purple',
  'fuchsia',
  'pink',
  'rose',
]

export const PRIMARY_COLOR_RGBA = {
  slate: 'rgba(100, 116, 139, 0.85)',
  gray: 'rgba(107, 114, 128, 0.85)',
  zinc: 'rgba(113, 113, 122, 0.85)',
  neutral: 'rgba(115, 115, 115, 0.85)',
  stone: 'rgba(120, 113, 108, 0.85)',
  red: 'rgba(239, 68, 68, 0.85)',
  orange: 'rgba(249, 115, 22, 0.85)',
  amber: 'rgba(245, 158, 11, 0.85)',
  yellow: 'rgba(234, 179, 8, 0.85)',
  lime: 'rgba(132, 204, 22, 0.85)',
  green: 'rgba(34, 197, 94, 0.85)',
  emerald: 'rgba(16, 185, 129, 0.85)',
  teal: 'rgba(20, 184, 166, 0.85)',
  cyan: 'rgba(6, 182, 212, 0.85)',
  sky: 'rgba(14, 165, 233, 0.85)',
  blue: 'rgba(59, 130, 246, 0.85)',
  indigo: 'rgba(99, 102, 241, 0.85)',
  violet: 'rgba(139, 92, 246, 0.85)',
  purple: 'rgba(168, 85, 247, 0.85)',
  fuchsia: 'rgba(217, 70, 239, 0.85)',
  pink: 'rgba(236, 72, 153, 0.85)',
  rose: 'rgba(244, 63, 94, 0.85)',
}
